'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _createWarnTooManyClasses = require('../utils/createWarnTooManyClasses');

var _createWarnTooManyClasses2 = _interopRequireDefault(_createWarnTooManyClasses);

var _validAttr = require('../utils/validAttr');

var _validAttr2 = _interopRequireDefault(_validAttr);

var _isTag = require('../utils/isTag');

var _isTag2 = _interopRequireDefault(_isTag);

var _isStyledComponent = require('../utils/isStyledComponent');

var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);

var _AbstractStyledComponent = require('./AbstractStyledComponent');

var _AbstractStyledComponent2 = _interopRequireDefault(_AbstractStyledComponent);

var _ThemeProvider = require('./ThemeProvider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Theme = require('./ThemeProvider').babelPluginFlowReactPropTypes_proptype_Theme || require('react').PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_Target = require('../types').babelPluginFlowReactPropTypes_proptype_Target || require('react').PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_RuleSet = require('../types').babelPluginFlowReactPropTypes_proptype_RuleSet || require('react').PropTypes.any;

var escapeRegex = /[[\].#*$><+~=|^:(),"'`]/g;
var multiDashRegex = /--+/g;

exports.default = function (ComponentStyle, constructWithOptions) {
  /* We depend on components having unique IDs */
  var identifiers = {};
  var generateId = function generateId(_displayName) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : _displayName.replace(escapeRegex, '-') // Replace all possible CSS selectors
    .replace(multiDashRegex, '-'); // Replace multiple -- with single -

    var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;

    var hash = ComponentStyle.generateName(displayName + nr);
    return displayName + '-' + hash;
  };

  var BaseStyledComponent = function (_AbstractStyledCompon) {
    _inherits(BaseStyledComponent, _AbstractStyledCompon);

    function BaseStyledComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseStyledComponent.__proto__ || Object.getPrototypeOf(BaseStyledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BaseStyledComponent, [{
      key: 'buildExecutionContext',
      value: function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;

        var context = _extends({}, props, { theme: theme });
        if (attrs === undefined) {
          return context;
        }

        this.attrs = Object.keys(attrs).reduce(function (acc, key) {
          var attr = attrs[key];
          // eslint-disable-next-line no-param-reassign
          acc[key] = typeof attr === 'function' ? attr(context) : attr;
          return acc;
        }, {});

        return _extends({}, context, this.attrs);
      }
    }, {
      key: 'generateAndInjectStyles',
      value: function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor,
            componentStyle = _constructor.componentStyle,
            warnTooManyClasses = _constructor.warnTooManyClasses;

        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext);

        if (warnTooManyClasses !== undefined) {
          warnTooManyClasses(className);
        }

        return className;
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        if (this.context[_ThemeProvider.CHANNEL]) {
          var subscribe = this.context[_ThemeProvider.CHANNEL];
          this.unsubscribe = subscribe(function (nextTheme) {
            // This will be called once immediately

            // Props should take precedence over ThemeProvider, which should take precedence over
            // defaultProps, but React automatically puts defaultProps on props.
            var defaultProps = _this2.constructor.defaultProps;

            var isDefaultTheme = defaultProps && _this2.props.theme === defaultProps.theme;
            var theme = _this2.props.theme && !isDefaultTheme ? _this2.props.theme : nextTheme;
            var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
            _this2.setState({ theme: theme, generatedClassName: generatedClassName });
          });
        } else {
          var _theme = this.props.theme || {};
          var generatedClassName = this.generateAndInjectStyles(_theme, this.props);
          this.setState({ theme: _theme, generatedClassName: generatedClassName });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        this.setState(function (oldState) {
          // Props should take precedence over ThemeProvider, which should take precedence over
          // defaultProps, but React automatically puts defaultProps on props.
          var defaultProps = _this3.constructor.defaultProps;

          var isDefaultTheme = defaultProps && nextProps.theme === defaultProps.theme;
          var theme = nextProps.theme && !isDefaultTheme ? nextProps.theme : oldState.theme;
          var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

          return { theme: theme, generatedClassName: generatedClassName };
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            children = _props.children,
            innerRef = _props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor,
            styledComponentId = _constructor2.styledComponentId,
            target = _constructor2.target;


        var isTargetTag = (0, _isTag2.default)(target);

        var className = [this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

        var baseProps = _extends({}, this.attrs, {
          className: className
        });

        if ((0, _isStyledComponent2.default)(target)) {
          baseProps.innerRef = innerRef;
        } else {
          baseProps.ref = innerRef;
        }

        var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
          // Don't pass through non HTML tags through to HTML elements
          // always omit innerRef
          if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || (0, _validAttr2.default)(propName))) {
            // eslint-disable-next-line no-param-reassign
            acc[propName] = _this4.props[propName];
          }

          return acc;
        }, baseProps);

        return (0, _react.createElement)(target, propsForElement, children);
      }
    }]);

    return BaseStyledComponent;
  }(_AbstractStyledComponent2.default);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? (0, _isTag2.default)(target) ? 'styled.' + target : 'Styled(' + target.displayName + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var warnTooManyClasses = void 0;
    if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
      warnTooManyClasses = (0, _createWarnTooManyClasses2.default)(displayName);
    }

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), componentId);

    var StyledComponent = function (_ParentComponent) {
      _inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        _classCallCheck(this, StyledComponent);

        return _possibleConstructorReturn(this, (StyledComponent.__proto__ || Object.getPrototypeOf(StyledComponent)).apply(this, arguments));
      }

      _createClass(StyledComponent, null, [{
        key: 'extendWith',
        value: function extendWith(tag) {
          var _ = options.displayName,
              __ = options.componentId,
              optionsToCopy = _objectWithoutProperties(options, ['displayName', 'componentId']);

          var newOptions = _extends({}, optionsToCopy, { rules: rules, ParentComponent: StyledComponent });
          return constructWithOptions(createStyledComponent, tag, newOptions);
        }
      }, {
        key: 'extend',
        get: function get() {
          return StyledComponent.extendWith(target);
        }
      }]);

      return StyledComponent;
    }(ParentComponent);

    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = componentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.warnTooManyClasses = warnTooManyClasses;
    StyledComponent.target = target;


    return StyledComponent;
  };

  return createStyledComponent;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/models/StyledComponent.js
// module id = 1366
// module chunks = 0